module.exports = __webpack_public_path__ + "img/fig15.48970c7a.jpg";